module.exports = __webpack_public_path__ + "img/manufacture-ala.93e9e164.jpg";